import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CommonService } from "../../../../services/common.service";
import { PlanService } from "../../../../services/plan.service";

@Component({
  selector: "plan-list-item",
  templateUrl: "./list-item.component.html",
})
export class PlanListItemComponent implements OnInit {
  @Input() inputData: any = {};
  @Input() plan: any = {};
  @Input() targetDay: any;
  @Input() hasTargetDay: boolean = false;
  @Input() isLast: boolean = false;
  @Input() viewedPlans: any = {};
  @Input() favouritePlans: any = {};

  @Output() setActivatedStation = new EventEmitter<any>();
  @Output() getFavouritePlans = new EventEmitter<any>();
  @Output() getViewedPlans = new EventEmitter<any>();

  public moment: any;
  public _: any;

  constructor(
    public commonService: CommonService,
    public planService: PlanService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  ngOnInit() {
    /* DO NOTHING NOW */
  }

  hasFixedPrice() {
    return (
      this.plan.source_id == this.commonService.appConfig.plan.sources.keio || this.plan.source_id == this.commonService.appConfig.plan.sources.kobo
    );
  }

  setFavourite(plan: any) {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    this.planService.setPlanFavourite(plan);

    /* RELOAD VIEWED & FAVOURITE PLANS */
    this.getViewedPlans.emit();
    this.getFavouritePlans.emit();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* EMIT TO PARENT */
  _setActivatedStation(station: any = {}) {
    this.setActivatedStation.emit(station);
  }
}
